(function () {
  if (window.__pdpTestimonialsInit) return;
  window.__pdpTestimonialsInit = true;

  function init() {
    // Pause a video and reset its play button state
    function pauseVideo(video) {
      if (!video || video.paused) return;
      video.pause();
      var wrap = video.closest('.pdp-test-video');
      var btn = wrap ? wrap.querySelector('.pdp-video-play-btn') : null;
      if (btn) btn.classList.remove('playing');
    }

    // Video play/pause toggle
    document.querySelectorAll('.pdp-video-play-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var video = this.closest('.pdp-test-video').querySelector('video');
        if (!video) return;
        if (video.paused) {
          video.muted = false;
          video.play();
          this.classList.add('playing');
        } else {
          video.pause();
          this.classList.remove('playing');
        }
      });
      var video = btn.closest('.pdp-test-video').querySelector('video');
      if (video) {
        video.addEventListener('ended', function () {
          btn.classList.remove('playing');
        });
      }
    });

    // Auto-pause when a video scrolls out of view (or the card is swiped away)
    var videos = document.querySelectorAll('.pdp-test-uploaded-video');
    if ('IntersectionObserver' in window) {
      var visibilityObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          // Pause once less than half the video is on screen.
          // Use intersectionRatio, NOT isIntersecting: isIntersecting only
          // becomes false when the video is 100% gone, and a single 0.5
          // threshold never fires a callback at that point.
          if (entry.intersectionRatio < 0.5) pauseVideo(entry.target);
        });
      }, { threshold: [0, 0.25, 0.5, 0.75, 1] });
      videos.forEach(function (v) { visibilityObserver.observe(v); });
    }

    // Auto-pause when the tab/app is hidden (user switches tab or minimizes)
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        videos.forEach(pauseVideo);
      }
    });

    // Carousel: swipe on mobile, and on desktop once there are more than 4 cards
    var slider = document.getElementById('pdpTestSlider');
    var dotsWrap = document.getElementById('pdpTestDots');
    if (!slider || !dotsWrap) return;

    function isMobile() { return window.innerWidth <= 960; }
    var desktopSlider = slider.classList.contains('pdp-test-grid--slider');
    function isSliding() { return isMobile() || desktopSlider; }

    var cards = slider.querySelectorAll('.pdp-test-card');
    var currentIndex = 0;
    var wrap = slider.parentElement;
    var prevBtn = wrap.querySelector('.pdp-test-arrow--prev');
    var nextBtn = wrap.querySelector('.pdp-test-arrow--next');

    // Desktop shows 4 cards at once, so the last stop is the 4th-from-last card
    function maxIndex() {
      return isMobile() ? cards.length - 1 : Math.max(0, cards.length - 4);
    }

    function updateArrows() {
      if (prevBtn) prevBtn.disabled = currentIndex <= 0;
      if (nextBtn) nextBtn.disabled = currentIndex >= maxIndex();
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(currentIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(currentIndex + 1); });

    function buildDots() {
      dotsWrap.innerHTML = '';
      if (currentIndex > maxIndex()) currentIndex = maxIndex();
      updateArrows();
      if (!isSliding() || maxIndex() < 1) { dotsWrap.style.display = 'none'; return; }
      dotsWrap.style.display = 'flex';
      for (var i = 0; i <= maxIndex(); i++) {
        var dot = document.createElement('button');
        dot.className = 'pdp-test-dot' + (i === currentIndex ? ' active' : '');
        dot.setAttribute('aria-label', 'Go to review ' + (i + 1));
        dot.dataset.index = i;
        dot.addEventListener('click', function () { goTo(parseInt(this.dataset.index)); });
        dotsWrap.appendChild(dot);
      }
    }

    function goTo(idx) {
      if (idx < 0) idx = 0;
      if (idx > maxIndex()) idx = maxIndex();
      currentIndex = idx;
      if (isSliding()) {
        slider.scrollTo({ left: cards[idx].offsetLeft - cards[0].offsetLeft, behavior: 'smooth' });
      }
      updateDots();
    }

    function updateDots() {
      dotsWrap.querySelectorAll('.pdp-test-dot').forEach(function (d, i) {
        d.classList.toggle('active', i === currentIndex);
      });
      updateArrows();
    }

    // Touch swipe
    var startX = 0, diffX = 0;
    slider.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    slider.addEventListener('touchmove', function (e) { diffX = e.touches[0].clientX - startX; }, { passive: true });
    slider.addEventListener('touchend', function () {
      if (!isMobile()) return;
      if (diffX > 50) goTo(currentIndex - 1);
      else if (diffX < -50) goTo(currentIndex + 1);
      diffX = 0;
    });

    // Scroll snap detection
    var scrollTimer;
    slider.addEventListener('scroll', function () {
      if (!isSliding()) return;
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var scrollLeft = slider.scrollLeft;
        var closest = 0, minDist = Infinity;
        for (var i = 0; i <= maxIndex(); i++) {
          var dist = Math.abs(cards[i].offsetLeft - cards[0].offsetLeft - scrollLeft);
          if (dist < minDist) { minDist = dist; closest = i; }
        }
        // Scrolled to the very end: the last stop is active even if not snapped exactly
        if (scrollLeft + slider.clientWidth >= slider.scrollWidth - 2) closest = maxIndex();
        currentIndex = closest;
        updateDots();
      }, 100);
    });

    buildDots();
    window.addEventListener('resize', buildDots);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
